import { useMutation } from "react-query";

import axios, { AxiosResponse } from "axios";
import { ChartRequestType } from "types";
import { ExportFormat } from "utils/exportUtils";
import * as z from "zod";

const chartServiceApiRoot = process.env.REACT_APP_CHART_SERVICE;

export const ExportChartDataResponseSchema = z.object({
  data: z.instanceof(Blob),
  status: z.number().min(200).max(299)
});

export type ExportChartDataResponse = z.infer<typeof ExportChartDataResponseSchema>;

export interface ExportChartDataParams {
  request: ChartRequestType;
  format: ExportFormat;
  filename: string;
}

export default function useExportChartDataMutation(
  onSuccess?: (response: AxiosResponse, params: ExportChartDataParams) => void,
  onError?: () => void
) {
  return useMutation(
    async ({ request, format }: ExportChartDataParams) => {
      const response = await axios.post(
        `${chartServiceApiRoot}/chart/export?exportformat=${format}`,
        request,
        {
          responseType: "blob"
        }
      );

      const validatedResponse = ExportChartDataResponseSchema.parse(response);
      return validatedResponse as AxiosResponse<Blob>;
    },
    {
      onSuccess: onSuccess
        ? (response, params) => onSuccess(response, params)
        : undefined,
      onError: onError
    }
  );
}
